var SCM = SCM || {};

SCM.Logging = (function() {
    var logger = {
        // Note that the logger does not have a log() function, because we should never be doing a console.log()
        debug: _debug,
        warn: _warn,
        error: _error
    };
    var jsDebugEnabled = null;


    return {
        init: _init,
        getLogger: function () { return logger; },
        isJsDebugEnabled: _isJsDebugEnabled
    };

    function _debug(msg) {
        if (_isJsDebugEnabled()) {
            console.log(msg);
        }
    }

    function _warn(msg) {
        console.warn(msg);
    }

    function _error(msg) {
        console.error(msg);
    }

    function _init() {
    }

    function _isJsDebugEnabled() {
        var jsDebugParam;
        return jsDebugEnabled !== null
            ? jsDebugEnabled
            : jsDebugEnabled = (jsDebugParam = new URLSearchParams(window.location.search).get('JsDebug'))
            && jsDebugParam === 'true';
    }
})();
